'use client'
import Link from "next/link";
// import ProductListNotFound from "@/components/ProductListNotFound";
export default function NotFound() {
  return (
    <div className="flex flex-col items-center pb-60 pt-20 bg-gray-100">
      <h1 className="text-4xl font-bold mt-8">Pagina no encontrada</h1>
      <p className="text-lg text-gray-500 mt-4">
        La pagina que buscas no existe o fue removida
      </p>
      <Link className="text-blue-500 mt-4" href="https://www.coppel.com/">
        Regresar al inicio
      </Link>

      {/* <div className="w-full flex container">
        <h2 className="text-2xl font-bold text-center mt-8">
          Te puede interesar
        </h2>
      </div> */}
      {/* <ProductListNotFound /> */}
    </div>
  );
}
